import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";

const Activesubscriber = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [page]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`activesubscriber?page=${page}`);

      setSubscribers(data.data);
      setLastPage(data.meta.last_page);
      setTotalRows(data.meta.total);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    await axios.delete(`activesubscriber/${id}`);
    setSubscribers((prev) => prev.filter((item) => item.id !== id));
    setTotalRows((prev) => prev - 1);
  };

  const formatDate = (date) => new Date(date).toLocaleString();

  return (
    <Wrapper pageTitle={"Active Subscribers"}>
      {/* <InnerNav
        createLink={"/activesubscriberCreate"}
        listLink={"/activesubscriber"}
      /> */}

      {/* Summary Bar */}
      <div className="flex justify-between items-center bg-gray-100 dark:bg-gray-800 p-3 rounded mb-4">
        <div>
          <strong>Total Rows:</strong> {totalRows}
        </div>
        <div>
          Page <strong>{page}</strong> of <strong>{lastPage}</strong>
        </div>
      </div>

      <div className="flex justify-left items-center gap-2 p-4 bg-gray-50 dark:bg-gray-800">
        <button
          disabled={page === 1}
          onClick={() => setPage(1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          First
        </button>

        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Prev
        </button>

        <span className="px-3">
          {page} / {lastPage}
        </span>

        <button
          disabled={page === lastPage}
          onClick={() => setPage((p) => p + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Next
        </button>

        <button
          disabled={page === lastPage}
          onClick={() => setPage(lastPage)}
          className="px-3 py-1 border rounded disabled:opacity-50"
        >
          Last
        </button>
      </div>

      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left uppercase border-b bg-gray-50 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref</th>
                <th className="px-4 py-3">Msisdn</th>
                <th className="px-4 py-3">Offer Code</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Shortcode</th>
                <th className="px-4 py-3">Channel</th>
                <th className="px-4 py-3">Charge</th>
                <th className="px-4 py-3">Time</th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>

            <tbody className="bg-white divide-y dark:bg-gray-800">
              {loading ? (
                <tr>
                  <td colSpan="9" className="text-center py-6">
                    Loading...
                  </td>
                </tr>
              ) : subscribers.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center py-6">
                    No records found
                  </td>
                </tr>
              ) : (
                subscribers.map((item) => (
                  <tr
                    key={item.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-3">{item.id}</td>
                    <td className="px-4 py-3">{item.msisdn}</td>
                    <td className="px-4 py-3">{item.offer_code}</td>
                    <td className="px-4 py-3">{item.type}</td>
                    <td className="px-4 py-3">{item.short_code}</td>
                    <td className="px-4 py-3">{item.channel}</td>
                    <td className="px-4 py-3">{item.charge_amount}</td>
                    <td className="px-4 py-3">{formatDate(item.time_in)}</td>
                    <td className="flex gap-2 px-4 py-3">
                      <Link
                        className="btn btn-sm btn-outline-secondary"
                        to={`/activesubscriber/${item.id}/edit`}
                      >
                        <AiFillEdit />
                      </Link>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => del(item.id)}
                      >
                        <AiFillDelete className="text-rose-500 text-lg" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Improved Pagination */}
        <div className="flex justify-left items-center gap-2 p-4 bg-gray-50 dark:bg-gray-800">
          <button
            disabled={page === 1}
            onClick={() => setPage(1)}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            First
          </button>

          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>

          <span className="px-3">
            {page} / {lastPage}
          </span>

          <button
            disabled={page === lastPage}
            onClick={() => setPage((p) => p + 1)}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>

          <button
            disabled={page === lastPage}
            onClick={() => setPage(lastPage)}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Last
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

export default Activesubscriber;
